<template>
  <div>
    <!-- Hero Section -->
    <Section>
      <div class="text-center max-w-4xl mx-auto">
        <h1 class="text-4xl md:text-5xl font-bold text-ink mb-6">
          {{ $t('who.title') }}
        </h1>
      </div>
    </Section>

    <!-- Roles Grid -->
    <Section background="gray">
      <RolesGrid />
    </Section>

    <!-- CTA Section -->
    <Section>
      <div class="text-center max-w-3xl mx-auto">
        <h2 class="text-3xl font-bold text-ink mb-4">
          Find Your Perfect Workflow
        </h2>
        <p class="text-lg text-muted mb-8">
          No matter your role, E2M adapts to your specific needs and responsibilities.
        </p>
        <BaseButton variant="primary" size="lg">
          {{ $t('common.requestDemo') }}
        </BaseButton>
      </div>
    </Section>
  </div>
</template>

<script setup lang="ts">
import { useHead } from '@vueuse/head'
import { useI18n } from 'vue-i18n'
import Section from '@/components/Section.vue'
import BaseButton from '@/components/BaseButton.vue'
import RolesGrid from '@/components/RolesGrid.vue'

const { t } = useI18n()

useHead({
  title: () => `${t('who.title')} - E2M`,
  meta: [
    { name: 'description', content: () => t('who.title') },
    { property: 'og:title', content: () => `${t('who.title')} - E2M` },
    { property: 'og:description', content: () => t('who.title') }
  ]
})
</script>